import { ImageLoaderCSSStyleImpl } from '../../imageloader/imageloadercss';


export class ToneRowImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            // objectFit: 'cover', 
            flex: 0.1,
            height: '100%',
            borderRadius:"8px 0px 0px 8px",
        };
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowimageloadercss.tsx